import { areaIcon } from './areaIcons';

const COUNT_WORDS = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];

/**
 * A changelog bullet shown as Figma 91:12570's two lines: its first sentence as
 * the title (without the final period), the rest as the description.
 */
export function splitHighlight(text) {
    const trimmed = text.trim();
    const match = trimmed.match(/^(.+?[.!?])\s+(\S[\s\S]*)$/);
    const [title, description] = match ? [match[1], match[2]] : [trimmed, ''];
    return { title: title.replace(/\.$/, ''), description };
}

/** Every highlight of the releases the user has not seen, newest release first, with its area icon. */
export function whatsNewItems(releases) {
    return releases.flatMap((release) =>
        release.highlights.map((highlight) => ({
            key: `${release.version}:${highlight.text}`,
            icon: areaIcon(highlight.areas),
            ...splitHighlight(highlight.text),
        }))
    );
}

/** "Three things you’ll notice right away." */
export function noticeLine(count) {
    if (count === 0) return 'This update brings fixes and improvements.';
    const number = COUNT_WORDS[count] ?? String(count);
    return `${number} ${count === 1 ? 'thing' : 'things'} you’ll notice right away.`;
}
